import _styled from "styled-components";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import * as styles from "./Picture.styles";
export var Picture = function Picture(_ref) {
  var _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    children = _ref.children,
    className = _ref.className,
    imgCss = _ref.imgCss,
    _ref$lazyLoading = _ref.lazyLoading,
    lazyLoading = _ref$lazyLoading === void 0 ? false : _ref$lazyLoading,
    onError = _ref.onError,
    onLoad = _ref.onLoad,
    src = _ref.src;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    showPlaceholder = _useState2[0],
    setShowPlaceholder = _useState2[1];
  var onImageError = function onImageError() {
    setShowPlaceholder(false);
    onError === null || onError === void 0 || onError();
  };
  var onImageLoad = function onImageLoad() {
    setShowPlaceholder(false);
    onLoad === null || onLoad === void 0 || onLoad();
  };
  return /*#__PURE__*/React.createElement("picture", {
    className: className
  }, children, /*#__PURE__*/React.createElement(_StyledImg, {
    alt: alt,
    loading: lazyLoading ? 'lazy' : 'eager',
    onError: onImageError,
    onLoad: onImageLoad,
    src: src,
    $_css: [showPlaceholder && styles.imagePlaceholder, imgCss]
  }));
};
var _StyledImg = /*#__PURE__*/_styled("img").withConfig({
  displayName: "Picture___StyledImg",
  componentId: "sc-1x8mkej-0"
})(["", ""], function (p) {
  return p.$_css;
});